var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0557 34C20.1568 34 22.2374 33.5862 24.1786 32.7821C26.1198 31.978 27.8836 30.7994 29.3694 29.3137C30.8551 27.828 32.0337 26.0641 32.8377 24.1229C33.6418 22.1817 34.0557 20.1012 34.0557 18C34.0557 15.8989 33.6418 13.8183 32.8377 11.8771C32.0337 9.93586 30.8551 8.17203 29.3694 6.68629C27.8836 5.20055 26.1198 4.022 24.1786 3.21793C22.2374 2.41385 20.1568 2 18.0557 2M18.0557 34C15.9545 34 13.8739 33.5862 11.9327 32.7821C9.99152 31.978 8.22769 30.7994 6.74196 29.3137C5.25622 27.828 4.07767 26.0641 3.27359 24.1229C2.46952 22.1817 2.05566 20.1012 2.05566 18C2.05566 15.8989 2.46952 13.8183 3.27359 11.8771C4.07767 9.93586 5.25622 8.17203 6.74196 6.68629C8.22769 5.20055 9.99152 4.022 11.9327 3.21793C13.8739 2.41385 15.9545 2 18.0557 2M18.0557 34C22.9641 34 25.0619 24.8213 25.0619 18C25.0619 11.1787 22.9641 2 18.0557 2M18.0557 34C13.1472 34 11.0494 24.8213 11.0494 18C11.0494 11.1787 13.1472 2 18.0557 2M2.94455 12.6667H33.1668M2.94455 23.3333H33.1668",
    stroke: "#283B49",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteIcon);
export default __webpack_public_path__ + "static/media/website-icon.7e31d54068c32454a79d22023559c8bf.svg";
export { ForwardRef as ReactComponent };